__turbopack_context__.v({
  "aboutProSection": "styles-module-scss-module__U9vSCa__aboutProSection",
  "eventsCalendarButton": "styles-module-scss-module__U9vSCa__eventsCalendarButton",
  "eventsCalendarDesktopLink": "styles-module-scss-module__U9vSCa__eventsCalendarDesktopLink",
  "eventsCalendarHeader": "styles-module-scss-module__U9vSCa__eventsCalendarHeader",
  "eventsCalendarMobileLink": "styles-module-scss-module__U9vSCa__eventsCalendarMobileLink",
  "founderLink": "styles-module-scss-module__U9vSCa__founderLink",
  "headingSection": "styles-module-scss-module__U9vSCa__headingSection",
  "headingSectionContent": "styles-module-scss-module__U9vSCa__headingSectionContent",
  "headingSectionText": "styles-module-scss-module__U9vSCa__headingSectionText",
  "headingSectionTitle": "styles-module-scss-module__U9vSCa__headingSectionTitle",
  "helpSectionContent": "styles-module-scss-module__U9vSCa__helpSectionContent",
  "imageProWrapper": "styles-module-scss-module__U9vSCa__imageProWrapper",
  "ourFounderImage": "styles-module-scss-module__U9vSCa__ourFounderImage",
  "ourFounderName": "styles-module-scss-module__U9vSCa__ourFounderName",
  "ourFounderNameDesktop": "styles-module-scss-module__U9vSCa__ourFounderNameDesktop",
  "ourFounderNameMobile": "styles-module-scss-module__U9vSCa__ourFounderNameMobile",
  "ourFounderPosition": "styles-module-scss-module__U9vSCa__ourFounderPosition",
  "ourFounderSection": "styles-module-scss-module__U9vSCa__ourFounderSection",
  "ourFounderSectionCaption": "styles-module-scss-module__U9vSCa__ourFounderSectionCaption",
  "ourFounderSectionContent": "styles-module-scss-module__U9vSCa__ourFounderSectionContent",
  "ourFounderSectionText": "styles-module-scss-module__U9vSCa__ourFounderSectionText",
  "ourFounderSectionTitle": "styles-module-scss-module__U9vSCa__ourFounderSectionTitle",
  "ourMissionSectionContent": "styles-module-scss-module__U9vSCa__ourMissionSectionContent",
  "ourMissionSectionText": "styles-module-scss-module__U9vSCa__ourMissionSectionText",
  "ourServiceSectionTitle": "styles-module-scss-module__U9vSCa__ourServiceSectionTitle",
  "proCategoryButton": "styles-module-scss-module__U9vSCa__proCategoryButton",
  "proDescription": "styles-module-scss-module__U9vSCa__proDescription",
  "proFlexContainer": "styles-module-scss-module__U9vSCa__proFlexContainer",
  "proSubtitle": "styles-module-scss-module__U9vSCa__proSubtitle",
  "proTitle": "styles-module-scss-module__U9vSCa__proTitle",
});
